import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";

const UploadVehicleImageModal = ({ showImageModal, handleCloseImageModal, handleDeleteImage, image }) => {
    return (
        <Modal show={showImageModal} onHide={handleCloseImageModal} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Voertuig foto</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center p-0">
                {image && (
                    <img 
                        src={image} 
                        alt="Voertuig" 
                        className="img-fluid" 
                        style={{ maxHeight: "80vh", width: "auto" }}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <button 
                    type="button" 
                    className="btn btn-danger" 
                    onClick={handleDeleteImage}
                >
                        Verwijder foto
                </button>
                <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={handleCloseImageModal}
                >
                        Sluiten
                </button>
            </Modal.Footer>
        </Modal>
    );
};

UploadVehicleImageModal.propTypes = {
    showImageModal: PropTypes.bool.isRequired,
    handleCloseImageModal: PropTypes.func.isRequired,
    handleDeleteImage: PropTypes.func.isRequired,
    image: PropTypes.string
};

export default UploadVehicleImageModal;
